import React from "react";
import s from "./Divider.module.scss";

const Divider = ({ margin, style }) => {
  return (
    <div
      style={{
        marginTop: margin,
        marginBottom: margin,
        ...style
      }}
      className={s.divider}
    ></div>
  );
};

export default React.memo(Divider);
